import api from './api';

export function getDeviation(username) {
  return api.get(`/api/v2/deviations/${username}`);
}

export function createDeviation(from, to) {
  return api.post('/api/v2/deviations', {
    from_username: from,
    to_username: to,
  });
}

export function deleteDeviation(username) {
  return api.delete(`/api/v2/deviations/${username}`);
}
